export default {
  xs: '1px',
  s: '2px',
  m: '4px',
  ml: '8px',
  l: '16px',
  xl: '24px',
  pill: '100vh',
  round: '50%',
};
